import React from 'react';
import { createRoot } from 'react-dom/client';
import { keyMap } from '@locales/lokalise/keyMap';
import { Notification } from 'components/library/Notification';
import { ConfirmModal } from './Confirm';
import { Modal } from './Modal';
import './style.scss';

const { body } = document;

const confirmRoot = document.createElement('div');

body.appendChild(confirmRoot);
const confirmRootInstance = createRoot(confirmRoot);

confirmRootInstance.render(<ConfirmModal title={keyMap.modalConfirm} className="confirm--modal" />);

const notificationRoot = document.createElement('div');

body.appendChild(notificationRoot);
const notificationRootContainer = createRoot(notificationRoot);

notificationRootContainer.render(<Notification />);

const ConfirmDialog = ConfirmModal;
const NotificationDialog = Notification;

export { ConfirmDialog, Modal, NotificationDialog };
